module.exports = __webpack_public_path__ + "static/media/Logo-p9.d8847777.png";